import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const BorderBoxContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  marginTop: '20px',
  padding: '16px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
}));

const BorderBoxTitle = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  top: '-12px',
  left: '16px',
  backgroundColor: theme.palette.background.paper,
  padding: '0 8px',
  zIndex: 1,
  fontSize: '1rem',
  fontWeight: 'bold',
}));

const BorderBox = ({ title, children, sx = {} }) => (
  <BorderBoxContainer sx={sx}>
    <BorderBoxTitle>{title}</BorderBoxTitle>
    {children}
  </BorderBoxContainer>
);

export default BorderBox;
